import { compact } from 'lodash';
import React from 'react';
import { withStoppedPropagation } from '../../helpers';
import { useTheme } from '../../themes';

export const MailTo: React.FC<{
  email: string;
  subject?: string;
  title?: string;
  className?: string;
  color?: 'primary';
}> = ({ email, title, subject, children, className, color }) => {
  const theme = useTheme();
  const queries =
    compact([subject && `subject=${encodeURIComponent(subject)}`]).join('&') ||
    null;
  const fullEmail = compact([email, queries]).join('?');
  return (
    <a
      className={className}
      href={`mailto:${fullEmail}`}
      title={title || email}
      onClick={withStoppedPropagation(() => {}, false)}
      style={
        color === 'primary'
          ? { color: theme.custom.colors.primary.main }
          : undefined
      }
    >
      {children || email}
    </a>
  );
};
